const STORAGE_KEY = 'app:lastActivity';

const IDLE_SECONDS = Number(process.env.UMI_APP_IDLE_SECONDS || 0);
export const IDLE_LIMIT_MS =
  IDLE_SECONDS > 0 ? IDLE_SECONDS * 1000 : 15 * 60 * 1000;

export const now = () => Date.now();

export const readLastActivity = () => {
  const v = localStorage.getItem(STORAGE_KEY);
  return v ? parseInt(v, 10) : 0;
};

export const bumpActivity = () => {
  localStorage.setItem(STORAGE_KEY, String(now()));
};
